/* NW sengeguide: retter de OEVRIGE materialers pristabeller. Tilfoejet 31-08-2026.

   HVORFOR EN FIL MERE: nw-sg-priser.js synkroniserer kun det materiale kunden ser
   lige nu. Men guiden laeser ogsaa priser paa ANDRE materialer end det viste.
   Konkret skriver updateAlt() i page.find-dit-sengetoj.liquid teksten
   "Bambus giver naturlig, temperaturregulerende komfort fra X kr." paa alle
   ikke-bambus-sider, og henter X fra materials.bambus.sizes[0].price.

   Paa en silke-side var bambus aldrig blevet synkroniseret, saa tallet kom fra
   fallback'en i nw-sg-1.js, som er den gamle 80%-pris. Der stod "fra 479 kr."
   hvor bambus 140x200 faktisk koster 599. Meldt af Mads 31/8 fra et skaermbillede.
   Det er samme prisfejl som 28/8, bare paa et sted vi ikke havde daekket.

   TO LAG, som resten af guiden:
   1) Straks: rettede fallback-tal, saa der aldrig staar et 2024-tal paa skaermen.
   2) Derefter: live-synkronisering af bambus fra Shopify, uanset hvilket materiale
      kunden ser, saa tallet foelger med ved naeste prisaendring. */
(function(){
  'use strict';

  /* Listepriser 31-08-2026. Kun fallback. Punkt 2 herunder overskriver med live-tal. */
  var FALLBACK = {
    bambus:   [{ v: '140×200', price: 599 }, { v: '140×220', price: 699 }, { v: '200×220', price: 999 }, { v: '240×220', price: 1199 }],
    egyptisk: [{ v: '140×200', price: 899 }, { v: '140×220', price: 999 }, { v: '200×220', price: 1299 }],
    silke:    [{ v: '140×200', price: 1999 }, { v: '140×220', price: 2099 }, { v: '200×220', price: 2999 }],
    hor:      [{ v: '140×200', price: 1199 }, { v: '140×220', price: 1299 }, { v: '200×220', price: 1999 }]
  };

  function norm(s){ return String(s || '').toLowerCase().replace(/×/g, 'x').replace(/\s+/g, '').replace(/cm/g, ''); }

  /* 1) Straks, foer noget bliver tegnet. */
  try{
    Object.keys(FALLBACK).forEach(function(k){
      if(typeof materials !== 'undefined' && materials[k]){
        materials[k].sizes = FALLBACK[k].slice();
      }
    });
  }catch(e){}

  /* 2) Live-synkronisering af bambus, uanset valgt materiale. Bambus er det eneste
        materiale hvis pris naevnes paa andre materialers sider. */
  function syncBambus(){
    try{
      if(typeof materials === 'undefined' || !materials.bambus){ return; }
      var h = materials.bambus.colors[0].handle;
      fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(p){
          if(!p || !p.variants){ return; }
          var nye = [];
          allSizes.forEach(function(s){
            var fundet = null, i, j;
            for(i = 0; i < p.variants.length && !fundet; i++){
              var o = p.variants[i].options || [];
              for(j = 0; j < o.length; j++){ if(norm(o[j]) === norm(s.id)){ fundet = p.variants[i]; break; } }
              if(!fundet && norm(p.variants[i].title).indexOf(norm(s.id)) === 0){ fundet = p.variants[i]; }
            }
            if(fundet){ nye.push({ v: s.id, price: Math.round(fundet.price / 100) }); }
          });
          if(!nye.length){ return; }
          var gl = materials.bambus.sizes || [];
          var a = gl.map(function(x){ return x.v + ':' + x.price; }).join('|');
          var b = nye.map(function(x){ return x.v + ':' + x.price; }).join('|');
          if(a === b){ return; }
          /* Skriv kun hvis bambus IKKE er det valgte materiale. Er den valgt,
             ejer nw-sg-priser.js tabellen og har allerede de rigtige tal. */
          try{ if(typeof chosen !== 'undefined' && chosen && chosen.mat === 'bambus'){ return; } }catch(e){}
          materials.bambus.sizes = nye;
          if(typeof renderResult === 'function'){ try{ renderResult(); }catch(e){} }
        })
        .catch(function(){});
    }catch(e){}
  }

  syncBambus();
  setTimeout(syncBambus, 3000);
})();